import React from "react";
import { FormattedMessage } from "react-intl";
import { Text } from "@vagastec/ensemble-core";

import {
  infoNovidadesStyle,
  tagInfoNovidadesStyle,
} from "./info-novidades.css";
import { vars } from "../theme.css";

export function InfoNovidades() {
  return (
    <div className={infoNovidadesStyle}>
      <div className={tagInfoNovidadesStyle}>
        <Text size="sm" fontColor={vars.color.white} weight={600}>
          Nova interface
        </Text>
      </div>
      <div>
        <Text
          size="sm"
          weight={600}
          as="p"
          size="sm"
          fontColor={vars.color.infoTag}
        >
          <FormattedMessage
            id="infoTransicaoAsp.texto"
            defaultMessage="A publicação de vaga está de cara nova!"
          />
        </Text>
      </div>
    </div>
  );
}
